var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownwardArrowIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_121_14935)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_121_14935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.94104 20.0814C9.52675 20.6395 10.4779 20.6395 11.0636 20.0814L18.5607 12.9382C19.1464 12.3801 19.1464 11.4738 18.5607 10.9158C17.975 10.3577 17.0238 10.3577 16.4381 10.9158L11.4994 15.6258V1.92865C11.4994 1.13843 10.8294 0.5 10 0.5C9.17064 0.5 8.50059 1.13843 8.50059 1.92865L8.50059 15.6214L3.56189 10.9202C2.97618 10.3622 2.02499 10.3622 1.43928 10.9202C0.853573 11.4783 0.853573 12.3846 1.43928 12.9427L8.93635 20.0859L8.94104 20.0814Z",
    fill: "#222"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_121_14935"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "matrix(0 1 -1 0 20 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_121_14935"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "matrix(0 1 -1 0 20 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownwardArrowIcon);
export default __webpack_public_path__ + "static/media/DownwardArrowIcon.f54fa956746fc88d4ebc3da1df9e279e.svg";
export { ForwardRef as ReactComponent };